import React, { Fragment } from 'react'
import is from '../utility/is'

import './AgentBanner.css'

export default ({ children }) => {
  if (is.agentUser()) {
    return <div className="agent-banner">{children}</div>
  }

  return <Fragment>{children}</Fragment>
}
